import { useQuery } from "react-query";
import {
  getActiveAgreementsCount,
  getAllAgreementsCount,
} from "../../../../actions/CarrierAgreementMgmt/Agreements";

const useActiveAgreementCount = () => {
  return useQuery("GetActiveAgreementCount", getActiveAgreementsCount, {
    refetchOnWindowFocus: false,
  });
};

export default useActiveAgreementCount;
